import React from 'react';
import PropTypes from 'prop-types';

const MenuItemSeparator = ({ label, className, style }) => (
    <li
        className={`site-dropdown__separator text-center ${className}`}
        style={style}>
        {label}
    </li>
);

MenuItemSeparator.defaultProps = {
    className: '',
    style: {}
};

MenuItemSeparator.propTypes = {
    label: PropTypes.node,
    className: PropTypes.string,
    style: PropTypes.object
};

export default MenuItemSeparator;
